export default {
  // General
  app_name: 'mvplan',
  calculate: 'Dekompression berechnen',
  save: 'Speichern',
  cancel: 'Abbrechen',
  add: 'Hinzufügen',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  reset: 'Zurücksetzen',
  confirm_reset: 'Alle Einstellungen zurücksetzen?',
  confirm_delete: 'Diesen Eintrag löschen?',

  // Navigation
  nav_plan: 'Plan',
  nav_gases: 'Gase',
  nav_profile: 'Profil',
  nav_settings: 'Einstellungen',
  nav_day: 'Tag',

  // Tauchtag
  day_title: 'Tauchtag',
  day_empty: 'Noch kein Tauchgang an diesem Tag.',
  day_empty_hint: 'Fügen Sie den Tauchgang des Planbildschirms hinzu, um eine Serie zu beginnen.',
  day_add_current: 'Aktuellen Tauchgang hinzufügen',
  day_add_needs_segments: 'Der Planbildschirm enthält kein Segment: nichts hinzuzufügen.',
  day_ask_surface_interval: 'Oberflächenintervall vor diesem Tauchgang, in Minuten:',
  day_invalid_surface_interval: 'Geben Sie ein Oberflächenintervall von 0 min oder mehr ein.',
  day_surface_interval: 'Oberflächenintervall',
  day_dive_label_placeholder: 'Name des Tauchgangs (optional)',
  day_calculate: 'Tag berechnen',
  day_clear: 'Tag leeren',
  day_confirm_clear: 'Alle Tauchgänge dieses Tages entfernen?',
  day_remove_dive: 'Diesen Tauchgang entfernen',
  day_confirm_remove: 'Die folgenden Tauchgänge hängen an diesem und müssen neu berechnet werden.',
  day_dive_not_computed: 'Noch nicht berechnet',
  day_dive_stale: 'Vor einer Änderung berechnet: Dieser Plan beschreibt die Serie nicht mehr.',
  day_dive_refused: 'Tauchgang abgelehnt, prüfen Sie die vorherigen Tauchgänge der Serie.',
  day_dives_refused: '{count} Tauchgang/Tauchgänge konnten nicht geplant werden. Die folgenden hängen an einem Tauchgang, den es nicht gibt.',
  day_summary: 'Tagessumme',
  day_dives_count: 'Tauchgänge',
  day_summary_partial: 'Die Summen umfassen {computed} von {total} berechneten Tauchgängen.',
  day_editing_dive: 'Sie bearbeiten Tauchgang {number} des Tages.',
  day_save_into_day: 'Im Tag speichern',
  day_detach: 'Lösen',
  day_dive_number: 'Tauchgang {number} von {total}',
  day_first_dive: 'Erster Tauchgang des Tages',
  day_nothing_to_export: 'Kein Tauchgang dieses Tages wurde berechnet: nichts zu exportieren.',
  day_export_failed: 'Das Dokument konnte nicht erstellt werden. Versuchen Sie es erneut und prüfen Sie die Browser-Konsole.',

  // Saved days
  saved_days_title: 'Gespeicherte Tage',
  saved_days_save: 'Tag speichern',
  saved_days_saved: 'Tag gespeichert',
  saved_days_save_failed: 'Dieser Tag konnte nicht gespeichert werden: Er enthält keinen Tauchgang, oder der Speicher ist voll.',
  saved_days_name_placeholder: 'z.B. Port-Cros, Samstag',
  saved_days_empty: 'Noch kein Tag gespeichert.',
  saved_days_empty_hint: 'Stellen Sie einen Tauchtag zusammen und speichern Sie ihn, um ihn hier wiederzufinden.',
  saved_days_confirm_delete: 'Diesen Tag löschen?',
  saved_days_import_error: 'Diese Datei ist kein von mvplan exportierter Tauchtag.',

  // Settings
  settings_algorithm: 'Algorithmus',
  settings_gf: 'Gradientenfaktoren',
  settings_gf_low: 'GF Tief',
  settings_gf_high: 'GF Hoch',
  settings_rates: 'Geschwindigkeiten & Stopps',
  settings_descent: 'Abstieg',
  settings_ascent: 'Aufstieg',
  settings_deco_ascent: 'Zwischen Stopps',
  settings_last_stop_ascent: 'Letzter Aufstieg',
  settings_last_stop: 'Letzter Stopp',
  settings_safety_stop: 'Sicherheitsstopp ohne Dekopflicht (min, 0 = keiner)',
  settings_rmv: 'AMV',
  settings_rmv_bottom: 'Grund',
  settings_rmv_deco: 'Deko / Bailout',
  settings_ccr: 'CCR Modus',
  settings_setpoint_mode: 'Setpoint Modus',
  settings_setpoint_fixed: 'Fest',
  settings_setpoint_dynamic: 'Dynamisch',
  settings_ppo2: 'ppO2 Grenzen',
  settings_ppo2_working: 'Arbeit',
  settings_ppo2_deco: 'Deko',
  settings_display: 'Anzeige',
  settings_units: 'Einheiten',
  settings_units_metric: 'Metrisch (m, bar)',
  settings_units_imperial: 'Imperial (ft, psi)',
  settings_theme: 'Design',
  settings_theme_dark: 'Dunkel',
  settings_theme_light: 'Hell',
  settings_language: 'Sprache',
  settings_divers: 'Taucher',
  settings_divers_hint: 'Namen auf dem PDF (kommagetrennt)',
  settings_dive_site: 'Tauchplatz',
  settings_dive_site_placeholder: 'z.B. Blue Hole, Dahab',
  settings_bailout: 'Bailout',
  settings_bail_delay: 'Bailout-Verzögerung (min)',
  settings_bail_delay_hint: 'Zeit in der Tiefe vor dem Aufstieg beim Bailout',
  settings_rmv_stress: 'Stress AMV',
  settings_stress_until: 'Stress bis',
  settings_stress_first_stop: 'Erster Stopp',
  settings_stress_gas_switch: 'Gaswechsel',
  settings_stress_surface: 'Oberfläche',
  settings_time_and_gas: 'Zeiten und Gaswechsel',
  settings_descent_included: 'Abstiegszeit inklusive',
  settings_descent_included_hint: 'Abstiegszeit ist in der Segmentdauer enthalten',
  settings_gas_switch_duration: 'Dauer des Gaswechsels',
  settings_gas_switch_at_stop: 'Gaswechsel nur am Dekostopp',
  settings_gas_switch_at_stop_hint: 'Wenn deaktiviert, erfolgt der Gaswechsel sobald die MOD es erlaubt (optimaler)',
  settings_gf_presets: 'GF Voreinstellungen',
  settings_gf_presets_hint: 'Schnellzugriff in der Planansicht',
  settings_gf_add_preset: 'Voreinstellung hinzufügen',
  settings_gf_preset_name: 'Name',
  settings_gf_custom: 'Benutzerdefiniert',
  settings_environment: 'Umgebung',
  settings_gas_temp: 'Gastemp.',
  settings_water_type: 'Wasserart',
  settings_water_salt: 'Salzwasser',
  settings_water_fresh: 'Süßwasser',
  settings_water_brackish: 'Brackwasser',
  settings_water_red_sea: 'Rotes Meer',
  settings_water_custom: 'Eigene Dichte',
  settings_water_density: 'Wasserdichte',
  settings_water_density_hint: 'Die Wasserdichte verändert den tatsächlich wirkenden Druck in einer bestimmten Tiefe und damit die Dauer der Stopps. Richtwerte: 10000 im Süßwasser, 10150 im Brackwasser, 10300 im Meer, 10400 im Roten Meer (10300 entspricht 1.03 kg/l). Zulässige Werte: {min} bis {max}.',
  settings_altitude: 'Höhe',
  settings_environment_hint: 'Gastemp. = Lungentemperatur für die Dichteberechnung (~35°C). Höhe und Wasserart verändern auch die Dekompressionsberechnung.',
  settings_alerts: 'Sicherheitswarnungen',
  settings_alerts_hint: 'Warnungen für erfahrene Taucher deaktivieren',
  settings_alerts_narcosis: 'Narkose-Warnungen (END)',
  settings_alerts_density: 'Dichte-Warnungen (CO2)',
  settings_alerts_show_density: 'Gasdichte immer anzeigen',
  settings_ccr_flush: 'Kreislaufspülungen (CCR)',
  settings_ccr_flush_hint: 'Fügt dem Planungsbildschirm einen Spüleditor für Tauchgänge mit Kreislaufgerät hinzu.',
  settings_ccr_flush_duration: 'Standarddauer der Spülung (min)',
  settings_ccr_o2_flush: 'Tauchgangsende mit 100% Sauerstoff',
  settings_ccr_o2_flush_hint: 'In der eingestellten Tiefe wechselt der Kreislauf auf reinen Sauerstoff und bleibt bis zur Oberfläche darauf.',
  settings_ccr_o2_flush_depth: 'Tiefe (m)',
  settings_ccr_o2_flush_time: 'Spüldauer (min)',
  settings_ccr_o2_flush_invalid: 'Unbrauchbare Tiefe oder Dauer.',
  settings_alerts_icd: 'ICD-Warnungen (Innenohr)',
  settings_pdf: 'PDF-Export',
  settings_pdf_include_profile: 'Tauchprofil einschließen',
  settings_pdf_include_profile_hint: 'Deaktivieren, um auf eine A4-Seite zu passen',
  settings_school_mode: 'Schulmodus',
  settings_school_mode_hint: 'GF-Voreinstellungen auf dem Profildiagramm vergleichen',
  settings_chart_scale: 'Diagrammskalierung',
  settings_school_presets: 'Voreinstellungen zum Vergleichen',
  profile_school_compare: 'GF-Vergleich',
  profile_school_tts: 'TTS',
  profile_school_stops: 'Stopps',

  // Gases
  gases_title: 'Gasgemische',
  gases_bailout: 'Bailout Gase',
  gases_diluents: 'Verdünnungsmittel',
  gases_name: 'Name',
  gases_mod: 'MOD',
  gases_end: 'END',
  gases_ppo2_max: 'ppO2 max',
  gases_use_bailout: 'Als Bailout verwenden',
  gases_tank_config: 'Flaschenkonfiguration',
  gases_volume: 'Volumen (L)',
  gases_pressure: 'Druck (bar)',
  gases_capacity: 'Kapazität',

  // Plan
  plan_segments: 'Tauchsegmente',
  plan_depth: 'Tiefe',
  plan_time: 'Zeit',
  plan_runtime: 'Laufzeit',
  plan_gas: 'Gas',
  plan_setpoint: 'SP',
  plan_no_segments: 'Keine Segmente. Fügen Sie eines hinzu.',
  plan_config: 'Konfiguration',
  plan_ccr: 'CCR Plan',
  plan_bailout: 'Bailout (Schlimmster Fall)',
  plan_deco: 'Dekompressionsplan',
  plan_no_deco: 'Keine Dekompression erforderlich',
  plan_stops_summary: 'Deko-Stopps Übersicht',
  duration_hours_minutes: '{h} h {m}',
  duration_hours: '{h} h',
  duration_minutes: '{m} min',
  plan_desat_sea_level: 'Wenn Sie auf Meereshöhe bleiben, sind Sie {time} nach dem Verlassen des Wassers vollständig entsättigt.',
  plan_desat_altitude: 'Wenn Sie auf {altitude} m Höhe bleiben, sind Sie {time} nach dem Verlassen des Wassers vollständig entsättigt.',
  plan_desat_over: 'Die vollständige Entsättigung dauert mehr als {time} nach dem Verlassen des Wassers.',
  plan_no_fly: 'Flugverbot (DAN)',
  plan_no_fly_minimum: '> {time}',
  plan_no_fly_dan_rule: 'Wartezeit vor dem Fliegen, Konsensempfehlungen der DAN: mindestens {noStop} Oberflächenpause nach einem einzelnen Nullzeittauchgang; mindestens {multiDay} Oberflächenpause bei Wiederholungstauchgängen über mehrere Tage; deutlich mehr als {longer} nach Tauchgängen mit zwingender Dekompression oder mit Heliox und Trimix. Dies ist keine Entsättigungsberechnung.',
  plan_no_fly_dan_case_no_stop: 'Dieser Tauchgang fällt unter den ersten Fall: ein einzelner Tauchgang ohne Dekostopp.',
  plan_no_fly_dan_case_repetitive: 'Dieser Tauchgang fällt unter den zweiten Fall: Wiederholungstauchgang.',
  plan_no_fly_dan_case_deco: 'Dieser Tauchgang fällt unter den dritten Fall: zwingende Dekompression. Die angezeigte Wartezeit ist ein zu überschreitender Mindestwert, kein empfohlener Wert.',
  plan_no_fly_dan_case_helium: 'Dieser Tauchgang fällt unter den dritten Fall: Heliumgemisch. Die angezeigte Wartezeit ist ein zu überschreitender Mindestwert, kein empfohlener Wert.',
  plan_no_fly_dan_source: 'Quelle: DAN, Guidelines for Flying After Diving, Konsens des Flying After Recreational Diving Workshop (2002). Diese Versuche wurden in einer trockenen Druckkammer mit ruhenden Probanden durchgeführt: Für Taucher im Wasser und unter Belastung können längere Wartezeiten nötig sein.',
  plan_tts: 'TTS',
  plan_cns: 'CNS',
  plan_otu: 'OTU',
  plan_cns_series: 'CNS (Tag)',
  plan_otu_series: 'OTU (Tag)',
  plan_gas_requirements: 'Bailout Gasbedarf',
  plan_gas_consumption: 'Gasverbrauch',
  plan_liters: 'Liter',
  plan_type: 'Typ',
  plan_ppo2: 'ppO2',
  plan_density: 'Dichte',
  plan_tissue: 'Gewebe',
  plan_flush: 'Kreislaufspülungen',
  plan_flush_hint: 'Bewusste Spülungen des Kreislaufs während des Aufstiegs, von der grössten zur geringsten Tiefe. Während einer Spülung steht das gewählte Gemisch bei Umgebungsdruck im Kreislauf, nicht der Setpoint.',
  plan_flush_add: 'Spülung hinzufügen',
  plan_flush_none: 'Keine Spülung geplant',
  plan_flush_depth: 'Tiefe',
  plan_flush_gas: 'Spülen mit',
  plan_flush_time: 'Dauer',
  plan_flush_keep: 'Dieses Gemisch behalten',
  plan_flush_keep_hint: 'Der Kreislauf bleibt bis zur Oberfläche auf dem gespülten Gemisch, was der bewussten Heliumspülung vor der Dekompression entspricht. Nicht angehakt kehrt er zum verwendeten Diluent zurück: eine Spülung ist ein Handgriff, kein Gaswechsel.',
  plan_flush_remove: 'Entfernen',
  plan_flush_figures: '{gas} auf {depth} m: ppO2 {ppO2} bar, END {end} m, Dichte {density} g/L',
  plan_o2_flush_row: 'Ende auf Sauerstoff: {time} min Spülung auf {depth} m, Kreislauf bleibt bis zur Oberfläche auf Sauerstoff.',
  plan_o2_flush_source: 'In den CCR-Einstellungen festgelegt, hier nicht änderbar.',
  plan_o2_flush_skipped_setting: 'Das Sauerstoffende der Einstellungen hat eine unbrauchbare Tiefe oder Dauer und wird nicht angewandt.',
  plan_o2_flush_skipped_clash: 'Das Sauerstoffende der Einstellungen tritt auf {depth} m zurück: dort ist bereits eine eigene Spülung geplant.',
  plan_o2_flush_skipped_too_deep: 'Das auf {depth} m geplante Sauerstoffende wird nicht angewandt: dieser Tauchgang geht nie tiefer als {maxDepth} m.',
  plan_flush_helper: 'Berechnen',
  plan_flush_helper_title: 'Spültiefe',
  plan_flush_helper_hint: 'Geben Sie an, was Sie anstreben: die passende Tiefe wird für das Gemisch dieser Spülung sowie für Wasser und Höhe des Tauchplatzes berechnet.',
  plan_flush_helper_mix: 'Spülgemisch',
  plan_flush_helper_target: 'Ziel',
  plan_flush_target_ppo2: 'ppO2 (bar)',
  plan_flush_target_end: 'END (m)',
  plan_flush_helper_result: '{depth} m (genau {exact} m)',
  plan_flush_helper_rounding: 'Auf den flacheren Meter gerundet, die Werte unten sind also die des Plans.',
  plan_flush_helper_apply: 'Diese Tiefe übernehmen',
  plan_flush_helper_unreachable: 'Mit diesem Gemisch gibt es dafür keine Tiefe.',
  plan_flush_helper_deeper: 'Tiefer als der Grund bei {maxDepth} m: eine Spülung erfolgt im Aufstieg.',
  plan_flush_helper_no_nitrogen: 'Dieses Gemisch enthält keinen Stickstoff: sein END ist in jeder Tiefe null.',
  plan_flush_helper_band: 'Außerhalb Ihres Arbeitsbereichs {min} - {max} bar.',
  plan_descent: 'Abstieg',
  plan_ascent: 'Aufstieg',
  plan_bottom: 'Grund',
  plan_stop: 'Stopp',
  plan_total_runtime: 'Gesamtlaufzeit',
  plan_deco_time: 'Deko-Zeit',
  plan_max_depth: 'Max Tiefe',
  plan_bottom_time: 'Grundzeit',
  plan_based_on_rmv: 'Basierend auf AMV',
  plan_insufficient_gas: 'Eine oder mehrere Flaschen haben nicht genug Kapazität für dieses Bailout!',
  plan_bars_needed: 'bar benötigt',

  // Profile
  profile_title: 'Tauchprofil',
  profile_saturation: 'Gewebesättigung',
  profile_tap_details: 'Tippen für Details',
  profile_ceiling: 'Decke',
  profile_surface: 'Oberfläche',
  profile_residual: 'Rest-N2',
  profile_calculate_hint: 'Berechnen Sie einen Plan um das Profil zu sehen',
  profile_fullscreen: 'Vollbild',


  // Units
  unit_meters: 'm',
  unit_feet: 'ft',
  unit_minutes: 'min',
  unit_bar: 'bar',
  unit_psi: 'psi',
  unit_lpm: 'L/min',

  // Additional Plan
  plan_add_segment: 'Segment hinzufügen',
  plan_edit_segment: 'Segment bearbeiten',
  plan_diluent: 'Verdünnungsmittel',
  plan_dynamic_setpoint_info: 'Dynamischer Modus aktiv',
  plan_override_setpoint: 'Festen Setpoint erzwingen (optional)',
  plan_setpoint_auto: 'Auto',
  plan_mode: 'Modus',
  plan_algorithm: 'Algorithmus',
  plan_export_pdf: 'PDF exportieren',
  plan_save_html: 'HTML speichern',
  plan_calculate_first: 'Berechnen Sie zuerst einen Plan',
  plan_segment_for: '{depth}m für {time} min',
  plan_gas_at_sp: '{gas} @ SP{sp}',
  plan_tank: 'Flasche',
  plan_needed: 'Benötigt',
  plan_status: 'Status',
  plan_insufficient: 'UNZUREICHEND',
  plan_gas_tight: 'KNAPP',
  plan_ok: 'OK',
  plan_need_more: 'Es fehlen {liters}L ({bars} bar)',
  plan_left: '{liters}L übrig ({bars} bar)',
  plan_need_more_liters: 'Es fehlen {liters}L',
  plan_left_liters: '{liters}L übrig',
  plan_gas_unused: 'NICHT GEATMET',
  plan_gas_unused_detail: '{liters}L mitgeführt, von diesem Plan nie geöffnet',
  plan_gas_backup: 'Reserve: {names}',

  // Gases additional
  gases_name_auto: 'Name (auto wenn leer)',
  gases_auto_label: 'Auto-Label',
  gases_n2_calc: 'N2 % (berechnet)',
  gases_end_at_mod: 'END @ MOD',
  gases_confirm_delete: 'Dieses Gas löschen?',
  gases_confirm_delete_diluent: 'Dieses Verdünnungsmittel löschen?',
  gases_only_diluent: 'Kann das einzige Verdünnungsmittel nicht löschen',
  gases_form_invalid: 'Unbrauchbare Werte: O2 über 0 % und höchstens 100 %, He von 0 % bis unter 100 %, Summe höchstens 100 %; ppO2-Grenze, Flaschenvolumen und Druck über 0.',
  plan_segment_invalid: 'Geben Sie eine Tiefe von 1 bis 200 m, eine Dauer von 1 bis 999 min und einen Setpoint von 0,7 bis 1,6 bar ein.',

  // Segment types
  segment_bail: 'BAIL',
  segment_desc: 'Ab',
  segment_asc: 'Auf',
  segment_bottom: 'Grund',
  segment_stop: 'Stopp',
  segment_gas_change: 'Gaswech.',
  segment_diluent_change: 'Dil.wech.',
  segment_flush: 'Spülung',
  segment_safety_stop: 'Sicherh.',

  // Saved Plans
  nav_saved: 'Gespeichert',
  saved_plans_title: 'Gespeicherte Pläne',
  saved_plans_save: 'Plan speichern',
  saved_plans_saved: 'Plan gespeichert!',
  saved_plans_empty: 'Keine gespeicherten Pläne',
  saved_plans_empty_hint: 'Berechne einen Plan und speichere ihn',
  saved_plans_load: 'Laden',
  saved_plans_rename: 'Umbenennen',
  saved_plans_duplicate: 'Duplizieren',
  saved_plans_export: 'Exportieren',
  saved_plans_confirm_delete: 'Diesen Plan löschen?',
  saved_plans_import: 'Importieren',
  saved_plans_import_error: 'Import fehlgeschlagen',
  saved_plans_name_label: 'Planname',
  saved_plans_name_placeholder: 'Planname eingeben',
  plan_share: 'Teilen',
  feature_next_version: 'Verfügbar in der nächsten Version',

  // Dive environment carried by a plan: named in the exports and in the saved
  // plan list, and flagged when the plan on screen was computed for another one
  plan_environment_changed: 'Dieser Plan wurde für eine andere Wasserart oder eine andere Höhe berechnet. Berechnen Sie ihn vor dem Tauchgang neu.',
  // Any other input the calculation reads (gradient factors, rates, ppO2
  // limits, gases, rebreather...) changed after the plan was computed
  plan_inputs_changed: 'Dieser Plan wurde mit anderen Tauchparametern berechnet. Berechnen Sie ihn vor dem Tauchgang neu.',
  export_environment: 'Umgebung',
  saved_plan_environment: 'Umgebung',

  // PDF Export
  pdf_title: 'Tauchplan - mvplan',
  pdf_exporting: 'PDF wird erstellt...',
  pdf_generated: 'Erstellt am',
  pdf_mode_oc: 'Offener Kreislauf',
  pdf_footer_generated: 'Erstellt mit mvplan - Technischer Tauchplaner',
  pdf_footer_verify: 'Überprüfen Sie immer Ihren Tauchplan und führen Sie Reservetabellen mit',

  // PDF format choice
  pdf_choose_format: 'PDF-Format',
  pdf_choose_format_hint: 'Wählen Sie das zu exportierende Dokument',
  pdf_format_complete: 'Vollständig',
  pdf_format_complete_hint: 'Detaillierter mehrseitiger Bericht (Tabellen, Profil, Gas)',
  pdf_format_condensed: 'Kompakt (1 Seite)',
  pdf_format_condensed_hint: 'Druckbares Planungsblatt auf einer Seite',

  // PDF condensed form
  pdf_form_title: 'Tauchplanung',
  pdf_form_date: 'Datum',
  pdf_form_team: 'Gruppe Nr.',
  pdf_form_diver: 'Taucher',
  pdf_form_lastname: 'Vor-/Nachname',
  pdf_form_machine: 'Gerät',
  pdf_form_gf: 'Grad. Fac.',
  pdf_form_runtime_title: 'Run Time',
  pdf_form_planned_depth: 'Geplante Tiefe',
  pdf_form_planned_bottom: 'Geplante Grundzeit',
  pdf_form_palier: 'Stopptiefe',
  pdf_form_descent: 'Abstieg',
  pdf_form_bottom: 'Grund',
  pdf_form_duration: 'Dauer',
  pdf_form_cumul: 'Kumul.',
  pdf_form_mutualized: 'Geteilt',
  pdf_form_vol_liters: '% / Vol. in Litern',
  pdf_form_col_pct: '%',
  pdf_form_col_vol: 'Vol.',
  pdf_form_col_press: 'Druck',
  pdf_form_col_liters: 'Lit.',
  pdf_form_yes: 'ja',
  pdf_form_no: 'nein',
  pdf_form_gas_switch_legend: 'Gaswechsel',
  pdf_form_gas_verdict_legend: "Feld Lit. von Taucher 1: grün = OK, orange = knapp, rot = zu wenig für den Bailout-Aufstieg, grau = nicht geatmet. Zahlen in der rechten Spalte.",
  pdf_form_dtr: 'TTS',

  // Safety Alerts
  alerts_summary_title: 'Prüfpunkte für diesen Plan',
  alert_hypoxia: 'ppO2 {value} bar unter dem Minimum von 0.16 bar: Dieses Gemisch ist in dieser Tiefe nicht atembar. Planen Sie ein sauerstoffreicheres Gemisch ein.',
  alert_hyperoxia: 'ppO2 {value} bar über dem Maximum von 1.6 bar. Reduzieren Sie den Sauerstoffanteil oder nutzen Sie dieses Gas weniger tief.',
  alert_end_critical: 'END {value}m über der Grenze von 40m. Fügen Sie dem Bodengemisch Helium hinzu, um die Narkose zu verringern.',
  alert_end_high: 'END {value}m über den empfohlenen 30m. Ein heliumreicheres Gemisch verringert die Narkose.',
  alert_density_critical: 'Gasdichte {value} g/L über den empfohlenen 6.2 g/L: Das Atmen kann in dieser Tiefe schwerer werden. Fügen Sie dem Bodengemisch Helium hinzu.',
  alert_density_high: 'Gasdichte {value} g/L über den am Rebreather empfohlenen 5.2 g/L. Vermeiden Sie Anstrengung oder erhöhen Sie den Heliumanteil im Diluent.',
  alert_narcosis_increase: 'ppN2 steigt beim Wechsel auf Bailout von {ccrValue} auf {value} bar: mehr Narkose als am Rebreather. Ein heliumreicheres Bailout mildert den Übergang.',
  alert_end_increase: 'END steigt beim Wechsel auf Bailout von {ccrValue}m auf {value}m. Ein heliumreicheres Bailout verringert diesen Unterschied.',
  alert_icd_risk: 'Helium fällt bei diesem Gaswechsel von {prevValue}% auf {value}%. Ein schrittweiser Wechsel (Zwischengemisch) vermeidet isobare Gegendiffusion.',
  alert_ceiling_violation: 'Dieses Profil steigt auf {depth}m, obwohl die Deko-Decke bei {ceiling}m liegt. Bleiben Sie unter der Decke und verlängern Sie den Stopp vor dem Aufstieg.',
  alert_stop_time_truncated: 'Stopp auf {depth}m bei {time} min gekappt: Die interne Rechengrenze wurde erreicht, ohne die Decke freizugeben. Dieser Plan ist unvollständig, nicht danach tauchen - Grundzeit kürzen, ein Dekogas ergänzen oder GF Hoch erhöhen.',
  alert_runtime_limit: 'Berechnung an der internen Laufzeitgrenze von {runtime} min abgebrochen: Dieser Plan ist unvollständig, nicht danach tauchen - Tauchgang kürzen oder ein sauerstoffreicheres Dekogas ergänzen.',
  alert_entry_ceiling: 'Deckenwert von {ceiling}m zu Beginn dieses Tauchgangs, mit den hier eingestellten Gradientenfaktoren: Das Oberflächenintervall von {interval} min löst den vorherigen Tauchgang nicht auf, der Taucher schuldet bereits vor dem Wiedereinstieg einen Stopp. Dieser Plan holt das beim Aufstieg nach - verlängern Sie das Intervall vor dem Tauchgang.',
  alert_residual_state_unloaded: 'Restgewebezustand ohne jede Sättigung: Er soll auf einen Tauchgang folgen, doch kein einziges Kompartiment liegt über seinem Ruhewert. Dieser Plan ist damit kürzer als derselbe Tauchgang auf unbelasteten Geweben - tauchen Sie ihn nicht, berechnen Sie den vorherigen Tauchgang neu.',
  alert_default_gas_fallback: 'Kein aktives Gasgemisch: Dieser Plan wurde standardmäßig mit Luft berechnet. Er entspricht nicht den von Ihnen konfigurierten Gasen - aktivieren Sie in der Gase-Ansicht mindestens ein Gemisch und berechnen Sie vor dem Tauchgang neu.',
  alert_gas_above_mod: 'Kein mitgeführtes Gas reicht bis {depth}m unter der dort geltenden ppO2-Grenze von {limit} bar: Dieser Plan lässt dort {gas} atmen, jenseits seiner MOD von {mod}m bei dieser Grenze, bei einem ppO2 von {ppO2} bar. Es ist das sauerstoffärmste Gemisch Ihrer Liste, standardmäßig und nicht von Ihnen gewählt - führen Sie ein für diese Tiefe geeignetes Gemisch mit oder erhöhen Sie die Grenze, bevor Sie tauchen.',
  alert_gas_switch_on_empty: 'Die Flasche mit {gas} ist bei {depth}m leer: Der dort angezeigte Gaswechsel ist kein von Ihnen geplanter Dekowechsel, sondern der Plan, der auf das Verbleibende ausweicht. Nehmen Sie mehr von diesem Gemisch mit oder planen Sie einen eigenen Wechsel oberhalb dieser Tiefe, bevor Sie tauchen.',
  alert_gas_exhausted: 'Alle in {depth}m nutzbaren Flaschen sind leer: ab dort verlangt dieser Plan Gas, das Sie nicht mehr dabeihaben. Erhöhen Sie das Volumen oder nehmen Sie ein Gemisch mit, das diese Tiefe erreicht, bevor Sie tauchen.',
  alert_gas_insufficient: 'Die Flaschen mit {gas} enthalten {capacity} L und dieser Plan atmet {liters} L davon: es fehlen {missing} L. Nehmen Sie mehr davon mit oder planen Sie einen kürzeren Tauchgang, bevor Sie tauchen.',
  alert_flush_not_reached: 'Die bei {depth}m geplante Kreislaufspülung findet nie statt: der Schlussaufstieg beginnt bei {ascentStart}m, darüber. Setzen Sie die Spülung flacher an oder machen Sie sie zur letzten Stufe des Tauchgangs.',
  alert_flush_ppo2: 'Die Spülung auf {depth}m mit {gas} bringt den Kreislauf auf {ppO2} bar Sauerstoff und damit über Ihren Arbeitsbereich {min} - {max} bar hinaus. Während einer Spülung gilt der Setpoint nicht: im Kreislauf steht das, was das Gemisch in dieser Tiefe liefert.',
  alert_o2_flush_too_deep: 'Das auf {depth}m geplante Sauerstoffende findet nie statt: dieser Tauchgang geht nie tiefer als {maxDepth}m, kein Aufstieg führt durch diese Tiefe.',

  // Plan validation errors
  plan_error_title: 'Plan kann nicht berechnet werden',
  plan_error_no_segments: 'Kein Tauchsegment: Fügen Sie mindestens ein Segment mit Tiefe und Zeit hinzu.',
  plan_error_invalid_depth: 'Ungültige Tiefe: Geben Sie für jedes Segment eine Tiefe von 0 m oder mehr ein (0 m ist ein Oberflächenintervall).',
  plan_error_invalid_time: 'Ungültige Zeit: Geben Sie für jedes Segment eine Dauer von 0 min oder mehr ein.',
  plan_error_invalid_gf: 'Ungültige Gradientenfaktoren: GF Tief muss kleiner oder gleich GF Hoch sein, beide größer als 0% und höchstens 100%.',
  plan_error_invalid_gas: 'Ungültiges Gasgemisch: Der O2-Anteil muss größer als 0% und höchstens 100% sein, der He-Anteil zwischen 0% und unter 100%, ihre Summe darf 100% nicht überschreiten.',
  plan_error_no_diluent: 'Kein gültiges Verdünnungsmittel: Wählen Sie in der Gase-Ansicht ein Verdünnungsmittel für den Kreislaufgerät-Tauchgang.',
  plan_error_invalid_setpoint: 'Ungültiger Setpoint: Geben Sie einen ppO2-Setpoint zwischen 0.4 und 1.6 bar ein, Grenzen eingeschlossen.',
  plan_error_no_bailout_gas: 'Kein aktives Bailout-Gas: Aktivieren Sie in der Gase-Ansicht mindestens ein Bailout-Gas, um das Bailout zu berechnen.',
  plan_error_invalid_config: 'Ungültige Planer-Einstellung: Eine Auf- oder Abstiegsgeschwindigkeit, eine Stopptiefe oder ein ppO2-Grenzwert liegt außerhalb des zulässigen Bereichs. Prüfen Sie die Planer-Einstellungen vor der Berechnung.',
  plan_error_invalid_tissue_state: 'Unbrauchbarer Restgewebezustand: Der vorherige Tauchgang der Serie konnte nicht gelesen werden. Berechnen Sie den vorherigen Tauchgang neu, bevor Sie diesen planen.',
  plan_error_invalid_surface_interval: 'Ungültiges Oberflächenintervall: Geben Sie eine Dauer von 0 min oder mehr zwischen dem vorherigen und diesem Tauchgang ein.',
  plan_error_invalid_flush: 'Ungültige Kreislaufspülung: geben Sie jeder Spülung eine Tiefe oberhalb des Grundes, eine Dauer über 0 min und nur eine Spülung je Tiefe.',
  plan_error_time_shorter_than_descent: 'Segmentdauer kürzer als der Abstieg: {depth} m zu erreichen dauert bei der eingestellten Abstiegsgeschwindigkeit {descentTime} min, das Segment hat aber nur {time} min. Die Abstiegszeit ist in der Segmentdauer enthalten (siehe Einstellungen): geben Sie eine längere Dauer ein oder deaktivieren Sie diese Option.',
  plan_error_segment_gas_unavailable: 'Segment {index} ({depth} m) ist auf {gas} geplant, das deaktiviert ist oder nicht mehr existiert. Aktivieren Sie dieses Gas in der Gasansicht oder wählen Sie ein anderes für das Segment.',
  plan_error_no_bailout_point: 'Der Kreislaufplan enthält keinen Bailout-Punkt: er wurde nicht von dieser Version des Planers erzeugt. Berechnen Sie den Kreislaufplan erneut, bevor Sie den Bailout planen.',

  // Dive Info
  plan_notes: 'Notizen',
  plan_notes_placeholder: 'Notizen für den gedruckten Plan (Erinnerungen, Anweisungen, etc.)',
  plan_divers_placeholder: 'Taucher für diesen Tauchgang',

  // App Store Links
  app_available_on: 'Verfügbar auf:',
  app_get_ios: 'Im App Store laden',
  app_get_android: 'Bei Google Play herunterladen',

  // Tissue compartment descriptions
  tissue_desc_1: 'Blut, Rückenmark',
  tissue_desc_2: 'Blut, Gehirn',
  tissue_desc_3: 'Gehirn, Nervengewebe',
  tissue_desc_4: 'Gut durchblutete Muskeln',
  tissue_desc_5: 'Haut, Eingeweide',
  tissue_desc_6: 'Muskeln, Organe',
  tissue_desc_7: 'Muskeln',
  tissue_desc_8: 'Muskeln, Bänder',
  tissue_desc_9: 'Sehnen, Bindegewebe',
  tissue_desc_10: 'Knorpel',
  tissue_desc_11: 'Knorpel, Knochen',
  tissue_desc_12: 'Knochen, Gelenke',
  tissue_desc_13: 'Knochen, Fett',
  tissue_desc_14: 'Fettgewebe',
  tissue_desc_15: 'Fett, Knochenmark',
  tissue_desc_16: 'Fett, Knochenmark',
  tissue_halftime: 'Halbwertszeit',
  tissue_speed_fast: 'schnelles Gewebe',
  tissue_speed_medium: 'mittleres Gewebe',
  tissue_speed_slow: 'langsames Gewebe',
  tissue_leading: 'Führendes Kompartiment',
  tissue_leading_detail: '{tissue} (C{num}) bestimmt Ihre Decke bei {ceiling}m - beladen bei {gf}% (GF {gfLow}/{gfHigh}, Grenze hier: {gfLimit}%)',
  tissue_leading_no_ceiling: '{tissue} (C{num}) ist am stärksten beladen - beladen bei {gf}% (GF {gfLow}/{gfHigh}, Grenze hier: {gfLimit}%)',
  tissue_detail_title: 'Kompartiment-Detail',
  tissue_detail_coefficients: '{algo}-Koeffizienten: a={a} (Übersättigungstoleranz), b={b} (Tiefenempfindlichkeit). Empirische Konstanten von Bühlmann - schnelle Gewebe (C1) tolerieren mehr (a=1.17), langsame Gewebe (C16) weniger (a=0.23).',
  tissue_detail_saturation: 'Sättigung',
  tissue_detail_gf_actual: 'Tatsächlicher GF',
  tissue_detail_no_supersaturation: 'Keine Übersättigung',
  tissue_detail_undersaturated: 'Dieses Kompartiment ist nicht übersättigt: Der Gewebedruck liegt unter dem Umgebungsdruck. Das GF-Konzept gilt nur bei Übersättigung (beim Aufstieg oder am Dekostopp).',
  tissue_detail_explanation: '{saturation}% Sättigung bedeutet nicht {saturation}% GF. Der GF ({gfActual}%) misst den genutzten Anteil der Spanne zwischen Umgebungsdruck und M-value. Mit GF High {gfHigh}% ist eine Sättigung von {saturation}% erwartungsgemäß.',
  tissue_detail_explanation_gf_low: 'GF Low ({gfLow}%) bestimmt die Tiefe des ersten Dekostopps. Hier erlaubt der Algorithmus dem Taucher erstmals anzuhalten: Das führende Kompartiment nutzt {gfUsed}% seiner Spanne zwischen Umgebungsdruck und M-value. Je niedriger der GF Low, desto tiefer beginnen die Stopps.',
  tissue_detail_explanation_interpolated: 'Zwischen dem ersten Stopp und der Oberfläche wird der GF linear von GF Low ({gfLow}%) zu GF High ({gfHigh}%) interpoliert. In dieser Tiefe beträgt die angewandte Grenze {gfUsed}%. Der tatsächliche GF dieses Kompartiments ist {gfActual}%.',

  // Disclaimer
  disclaimer_title: 'Haftungsausschluss',
  disclaimer_text: 'Diese Software ist nur eine Tauchplanungshilfe. Sie ersetzt weder Ausbildung noch Erfahrung oder Urteilsvermögen. Die Autoren übernehmen keine Haftung für Unfälle oder Zwischenfälle. Überprüfen Sie Ihren Plan immer mit anderen Mitteln und führen Sie Reservetabellen mit.',
  disclaimer_short: 'Nur Planungshilfe - ersetzt nicht Ausbildung oder Urteilsvermögen - keine Haftung',

  // Projekt unterstützen
  support_nav: 'Projekt unterstützen',
  support_nav_website: 'Das Projekt',
  support_title: 'MV-Plan unterstützen',
  support_intro: 'MV-Plan ist freie Software. Keine Werbung, kein Konto, keine Datensammlung, und alle Funktionen stehen allen offen. Das bleibt so.',
  support_costs_title: 'Was das Projekt kostet',
  support_cost_apple: 'Apple-Entwicklerkonto: 99 USD pro Jahr, auch wenn die App kostenlos ist.',
  support_cost_google: 'Google-Play-Entwicklerkonto: 25 USD einmalig.',
  support_cost_domain: 'Domain und Hosting der Website mvplan.org.',
  support_cost_time: 'Die Zeit für Entwicklung, Tests und Dokumentation des Planers.',
  support_amount: 'Ein paar Euro genügen. Die meisten Beiträge liegen zwischen 3 und 10 Euro, und das hilft bereits sehr.',
  support_nothing_unlocked: 'Ein Beitrag schaltet nichts frei: keine Bezahlversion, keine versteckte Option, keine Namensnennung. Die App bleibt für alle dieselbe.',
  support_thanks: 'Danke an alle, die bereits beigetragen haben.',
  support_button: 'Beitragen',
  support_link_label: 'Adresse der Seite',
  support_copy: 'Link kopieren',
  support_copied: 'Link kopiert',
  support_copy_failed: 'Kopieren nicht möglich, bitte die Adresse von Hand auswählen',
  support_open_hint: 'Wenn die Schaltfläche nichts öffnet, die Adresse oben in den Browser kopieren.',
  support_website_title: 'Das Projekt',
  support_website_intro: 'MV-Plan ist freie Software und entsteht in der Freizeit des Autors. Auf der Projektseite finden sich Dokumentation, Versionshinweise und Kontaktmöglichkeiten.',
  support_website_button: 'Projektseite öffnen'
}
